import { Directive, OnDestroy, ElementRef, HostBinding, OnInit, HostAttributeToken, inject } from '@angular/core';

@Directive({
  selector: '[stickyElement]',
  standalone: false,
})
export class StickyElement implements OnDestroy, OnInit {
  readonly stickyClass = inject(new HostAttributeToken('stickyElement'), { optional: true }) ?? 'is-sticky';
  readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  @HostBinding('style.border-top')
  readonly borderTop = '1px solid transparent';

  @HostBinding('style.position')
  readonly position = 'sticky';

  @HostBinding('style.top.px')
  readonly top: number = -1;

  readonly observer = new IntersectionObserver(
    ([e]) => e.target.classList.toggle(this.stickyClass, e.intersectionRatio < 1),
    { threshold: [1] },
  );

  ngOnInit(): void {
    this.observer.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
  }
}
